import { AbstractControl, ValidatorFn, UntypedFormControl, UntypedFormGroup, ValidationErrors } from '@angular/forms';

export function PasswordFirstNetIdValidator(userid: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
        if (control.value && control.value.includes(userid)) {
            return { valid: false };
        }
        return null;
    };
}

export function ConfirmPasswordMatchValidator(pwd: UntypedFormControl): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
        if (control.value && pwd && pwd.value && control.value !== pwd.value) {
            return { valid: false };
        }
        return null;
    };
}

export function PasswordMatchValidator(): ValidatorFn {
    return (group: UntypedFormGroup): ValidationErrors => {
        const newPassword = group.controls['newPassword'] || group.controls['userPassword'];
        const confirmPassword = group.controls['confirmPassword'];
        if (confirmPassword && confirmPassword.value && confirmPassword.value.indexOf(' ') !== -1) {
            const pwd = confirmPassword.value.replace(' ', '');
            confirmPassword.setValue(pwd);
        }
        if (newPassword && confirmPassword && newPassword.value && confirmPassword.value && newPassword.value !== confirmPassword.value) {
            return { passwordMatchError: true };
        }
        return null;
    };
}

export function EmailMatchValidator(): ValidatorFn {
    return (group: UntypedFormGroup): ValidationErrors => {
        const contactEmail = group.controls['contactEmail'];
        const confirmEmail = group.controls['confirmEmail'];
        if (contactEmail.value && confirmEmail.value
            && contactEmail.value.toLowerCase() !== confirmEmail.value.toLowerCase()) {
            return { emailMatchError: true };
        }
        return null;
    };
}

export function UserRoleRequired(): ValidatorFn {
    return (group: UntypedFormGroup): ValidationErrors => {
        const editEmployee0 = group.controls['editEmployee0'];
        const editEmployee1 = group.controls['editEmployee1'];
        const volunteerInput0 = group.controls['volunteerInput0'];
        const volunteerInput1 = group.controls['volunteerInput1'];
        if (!((editEmployee0 && editEmployee0.value) || (editEmployee1 && editEmployee1.value) ||
            (volunteerInput0 && volunteerInput0.value) || (volunteerInput1 && volunteerInput1.value))) {
            return { userRoleRequiredError: true };
        }
        return null;
    };
}